import React from 'react';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import ScLink from '@/components/Generic/SitecoreWrappers/ScLink';
import { Field, Item, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

type ItemCta = Item & {
  id: string;
  fields: {
    cta: LinkField;
  };
};

type ArticleInfogramTileProps = ComponentProps & {
  fields: {
    title?: Field<string>;
    description?: Field<string>;
    items?: ItemCta[];
  };
  params?: {
    background?: string;
  };
};

const ArticleInfogramTile: React.FC<ArticleInfogramTileProps> = ({ fields, rendering, params }) => {
  const ctaLinks = fields.items || [];
  const backgroundClass = params.background || 'background-white';

  return (
    <div className={backgroundClass}>
      {fields.title && <Text field={fields.title} tag="h4" className="background-to-change mb-2" />}

      {fields.description && (
        <Text
          field={fields.description}
          tag="p"
          className="background-to-change body-default text-grey mb-1"
        />
      )}

      <Placeholder name="abrdn-list" rendering={rendering} className="mb-4" />
      <Placeholder name="abrdn-article-infogram-tile" rendering={rendering} />

      {ctaLinks.length > 0 && (
        <div className="mt-auto d-flex flex-column align-items-start">
          {ctaLinks.map((field) => (
            <ScLink
              key={field.id}
              field={field.fields?.cta}
              className="mt-2 background-to-change inline-link tile-link d-inline-block"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ArticleInfogramTile;
